const semanticClassNames = {
  root: 'ratings-input',
  label: 'ratings-input__label',
} as const;

export default semanticClassNames;
